/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_td_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The comparison runs entirely in your browser — your text never leaves your device.`)
};

const es_td_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La comparación se ejecuta completamente en tu navegador — tu texto nunca abandona tu dispositivo.`)
};

const de_td_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Der Vergleich läuft vollständig in deinem Browser – dein Text verlässt dein Gerät nie.`)
};

const nl_td_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. De vergelijking draait volledig in uw browser — uw tekst verlaat uw apparaat nooit.`)
};

const fr_td_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. La comparaison s'exécute entièrement dans votre navigateur — votre texte ne quitte jamais votre appareil.`)
};

const it_td_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Il confronto viene eseguito interamente nel tuo browser — il tuo testo non lascia mai il tuo dispositivo.`)
};

const pt_br2_td_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A comparação é executada inteiramente no seu navegador — seu texto nunca sai do seu dispositivo.`)
};

const pt_td_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A comparação funciona totalmente no seu navegador — o seu texto nunca sai do seu dispositivo.`)
};

const ja_td_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。比較はブラウザ内で完全に実行されます。テキストはデバイスを離れることはありません。`)
};

const zh_td_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。比较过程完全在你的浏览器中进行——你的文本不会离开你的设备。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const td_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.td_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("td_faq2_a", locale)
	if (locale === "en") return en_td_faq2_a(inputs)
	if (locale === "es") return es_td_faq2_a(inputs)
	if (locale === "de") return de_td_faq2_a(inputs)
	if (locale === "nl") return nl_td_faq2_a(inputs)
	if (locale === "fr") return fr_td_faq2_a(inputs)
	if (locale === "it") return it_td_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_td_faq2_a(inputs)
	if (locale === "pt") return pt_td_faq2_a(inputs)
	if (locale === "ja") return ja_td_faq2_a(inputs)
	return zh_td_faq2_a(inputs)
};